<div class="modal fade due-date-modal" id="due-date-modal-1" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <div class="header d-flex flex-column p-3">
                    <div class="modal-close align-self-end" data-dismiss="modal">
                        <i class="fas fa-times pt-2 pl-2 close-icon"></i>
                    </div>
                    <img class="align-self-center mt-3" src="../../../../assets/Images/baby.svg" height="100"
                        width="150" alt="baby">
                </div>
                <form [formGroup]="dueForm">
                    <div class="d-flex flex-column p-3">
                        <span class="modal-sub-title">When was the first day of your last period?</span>
                        <span class="input-label mt-3">Day</span>
                        <select name="due day" id="due-day" class="form-control form-control-sm my-2"
                            (change)="validateDate()" formControlName="dueDay">
                            <option [value]="day" *ngFor="let day of dueDaysDrop">{{day}}</option>
                        </select>
                        <span class="input-label mt-3">Month</span>
                        <select name="due month" id="due-month" class="form-control form-control-sm my-2"
                            (change)="validateDate()" formControlName="dueMonth">
                            <option [value]="month.no" *ngFor="let month of months">{{month.text}}</option>
                        </select>
                        <span class="input-label mt-3">Year</span>
                        <select name="due year" id="due-year" class="form-control form-control-sm my-2"
                            (change)="validateDate()" formControlName="dueYear">
                            <option [value]="year" *ngFor="let year of years">{{year}}</option>
                        </select>
                        <button class="btn btn-theme mt-3 mb-1 align-self-center" data-dismiss="modal"
                            data-toggle="modal" data-target="#due-date-modal-2" [disabled]="!dueForm.valid || dateError"
                            (click)="calculateDueDate()">Calculate</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<div class="modal fade due-date-modal" id="due-date-modal-2" data-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content w-100">
            <div class="modal-body">
                <div class="header d-flex flex-column p-3">
                    <div class="modal-close align-self-end" data-dismiss="modal">
                        <i class="fas fa-times pt-2 pl-2 close-icon"></i>
                    </div>
                    <div class="calendar-bg align-self-center">
                        <img src="../../../../assets/Images/calendar icon.svg" height="45" width="45"
                            alt="calendar icon">
                    </div>
                    <span class="modal-text mt-2">Your due date is:</span>
                    <span class="modal-title mt-2">{{dueDate | date:'MMMM dd, yyyy'}}.</span>
                </div>
                <div class="d-flex flex-column p-3">
                    <span class="modal-sub-title align-self-center">Congratulations</span>
                    <span class="modal-sub-text align-self-center my-1">You are {{weeksPregnant}} weeks pregnant</span>
                    <circle-progress class="text-center my-1" [backgroundPadding]="-2" [percent]="progressPercent"
                        [animation]="true" [outerStrokeGradient]='true' [title]="progressTitle" [backgroundPadding]="10"
                        [showSubtitle]='false'></circle-progress>
                    <button class="btn btn-theme mt-3 mb-1 align-self-center" data-dismiss="modal" data-toggle="modal"
                        data-target="#due-date-modal-1">Calculate Again</button>
                </div>
            </div>
        </div>
    </div>
</div>